import React from "react";
import PropTypes from "prop-types";
import { Navbar, Nav, Image } from "react-bootstrap";
import AlmigLink from "../grundelemente/AlmigLink";
import "./Navizeile.css";

/* NavLink funktioniert auch, anstatt der <LinkContainer>+<NavItem> Konstruktion,
 * meldet aber erstens Fehler auf der Konsole (mit denen ich glaube ich gar nichts
 * zu tun habe), und zweitens ist die sichtbare Gestaltung weit weg von dem, was
 * react-bootstrap für <Nav bsStyle="tabs"> vorgesehen hat.
 */

const Navizeile = props => (
	<Navbar componentClass="header" className="Navizeile">
		<Navbar.Header>
			<Navbar.Toggle />
			<Navbar.Brand>
				{/* TODO: Linkziel abhängig vom Branding */}
				<a target="_blank" href={"http://www.almig.de"}
					rel="noopener noreferrer">
					{/* TODO: Firmenlogo abhängig vom Branding */}
					<Image src="/ALMiG_logo.png" />
				</a>
			</Navbar.Brand>
		</Navbar.Header>
		<Navbar.Collapse>
			<Nav pullRight bsStyle="tabs">
				<AlmigLink disabled={props.disabled || !props.rights.overview} to="/overview" />
				<AlmigLink disabled={props.disabled || !props.rights.analytics} to="/analysis" />
				<AlmigLink disabled={props.disabled || !props.rights.energy_balancing} to="/energy_balancing"/>
				<AlmigLink disabled={props.disabled || !props.rights.maintenance} to="/maintenance" />
				<AlmigLink disabled={props.disabled || !props.rights.errors} to="/error_log" />
				<AlmigLink disabled={props.disabled || !props.rights.settings} to="/settings" />
			</Nav>
		</Navbar.Collapse>
	</Navbar>
);

Navizeile.propTypes = {
	disabled: PropTypes.bool
	//branding: PropTypes.object.isRequired
};

export default Navizeile;
